<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">地形的种类</div>
		<case-form :schema="schemaTerrain" />

		<div class="fs4 fw7 lh125 mt6 mb2">请提供过去 3 年的攀爬活动详情</div>

		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">攀爬活动详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaClimbs(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: "您参与攀爬运动有多久？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingForHowLongCN`,
					props: {
						suggest: {
							typeIncludes: `climbingForHowLongCN`
						},
						createOptions: {
							type: `climbingForHowLongCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您参与攀爬运动有多频密？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingHowOftenCN`,
					props: {
						suggest: {
							typeIncludes: `climbingHowOftenCN`
						},
						createOptions: {
							type: `climbingHowOftenCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您的攀爬技术达至什么级别？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingLevelCN`,
					props: {
						suggest: {
							typeIncludes: `climbingLevelCN`
						},
						createOptions: {
							type: `climbingLevelCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您在什么季节进行攀爬运动？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingSeasonCN`,
					props: {
						suggest: {
							typeIncludes: `climbingSeasonCN`
						},
						createOptions: {
							type: `climbingSeasonCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否单独进行攀爬运动？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isClimbAloneCN`,
					props: {
						suggest: {
							typeIncludes: `isClimbAloneCN`
						},
						createOptions: {
							type: `isClimbAloneCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbAloneDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `climbAloneDetailsCN`
						},
						createOptions: {
							type: `climbAloneDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否使用绳索进行攀爬运动？ ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isClimbWithoutRopesCN`,
					props: {
						suggest: {
							typeIncludes: `isClimbWithoutRopesCN`
						},
						createOptions: {
							type: `isClimbWithoutRopesCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbWithoutRopesDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `climbWithoutRopesDetailsCN`
						},
						createOptions: {
							type: `climbWithoutRopesDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "一般使用的攀爬设备",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbingEquipmentUsedCN`,
					props: {
						suggest: {
							typeIncludes: `climbingEquipmentUsedCN`
						},
						createOptions: {
							type: `climbingEquipmentUsedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "未来有什么攀爬活动计划 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0plannedClimbsCN`,
					props: {
						suggest: {
							typeIncludes: `plannedClimbsCN`
						},
						createOptions: {
							type: `plannedClimbsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTerrain() {
			return [
				{
					label: "山径",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainTrailCN`,
					props: {
						suggest: {
							typeIncludes: `isTerrainTrailCN`
						},
						createOptions: {
							type: `isTerrainTrailCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "岩石",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainRockCN`,
					props: {
						suggest: {
							typeIncludes: `isTerrainRockCN`
						},
						createOptions: {
							type: `isTerrainRockCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "冰",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainIceCN`,
					props: {
						suggest: {
							typeIncludes: `isTerrainIceCN`
						},
						createOptions: {
							type: `isTerrainIceCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "雪地",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainSnowCN`,
					props: {
						suggest: {
							typeIncludes: `isTerrainSnowCN`
						},
						createOptions: {
							type: `isTerrainSnowCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "冰川",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isTerrainGlacierCN`,
					props: {
						suggest: {
							typeIncludes: `isTerrainGlacierCN`
						},
						createOptions: {
							type: `isTerrainGlacierCN`,
							dataType: "boolean"
						}
					}
				},
				// {
				// 	label: "Other",
				// 	component: "entityFact",
				// 	entity: "case.insureds[0]",
				// 	relation: "case.insureds[0].facts",
				// 	bindTo: `case.facts.insured0isTerrainOther`,
				// 	props: {
				// 		suggest: {
				// 			typeIncludes: `isTerrainOther`
				// 		},
				// 		createOptions: {
				// 			type: `isTerrainOther`,
				// 			dataType: "boolean"
				// 		}
				// 	}
				// },
				{
					label: "其他（详情）",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0terrainOtherDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `terrainOtherDetailsCN`
						},
						createOptions: {
							type: `terrainOtherDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaClimbs(i) {
			return [
				{
					label: "日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryDate${i}CN`
						},
						createOptions: {
							type: `climbHistoryDate${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: "山脉名称",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryMountain${i}CN`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryMountain${i}CN`
						},
						createOptions: {
							type: `climbHistoryMountain${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: "地点",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryLocation${i}CN`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryLocation${i}CN`
						},
						createOptions: {
							type: `climbHistoryLocation${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: "难度（如属高难度，请注明最高技术级数）",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0climbHistoryDifficulty${i}CN`,
					props: {
						suggest: {
							typeIncludes: `climbHistoryDifficulty${i}CN`
						},
						createOptions: {
							type: `climbHistoryDifficulty${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
